import { FaUsers, FaCalendarDay, FaCalendarWeek } from "react-icons/fa";
import { PiChartLineUpBold } from "react-icons/pi";
import axios from "axios";
import { useState, useEffect } from "react";
import ThemeSelector from "./ThemeSelector";
import AgentSidebar from "../layout/AgentSidebar";
import Header from "../layout/Header";

const DashboardCard = ({ title, icon, value }) => (
  <div className="p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
    <div className="flex items-center space-x-4">
      <div>{icon}</div>
      <div>
        <div className="text-lg font-semibold text-gray-900 dark:text-white">
          {title}
        </div>
        <div className="text-2xl mt-1 text-gray-700 dark:text-gray-200">
          {value !== undefined ? value : "—"}
        </div>
      </div>
    </div>
  </div>
);

function Dashboard() {
  const [data, setData] = useState({});
  const baseURL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const agentId = sessionStorage.getItem("agent_id");
        const accessToken = sessionStorage.getItem("access_token");

        console.log("Agent_id:", agentId);
        console.log("Access Token:", accessToken);

        const response = await axios.get(`${baseURL}/getAgentDashboardCount`, {
          headers: { Authorization: `Bearer ${accessToken}` },
          params: { agent_id: agentId },
        });
        setData(response.data);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <AgentSidebar />

      <div className="p-4 sm:ml-0 md:ml-28 lg:ml-64 min-h-screen overflow-y-auto">
        <div className="flex justify-end mb-4">
          <ThemeSelector />
        </div>

        {/* Cards Row 1 - 3 cards */}
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <DashboardCard
            title="Assigned Customers"
            icon={<FaUsers size={40} className="text-blue-500" />}
            value={data?.customer_count}
          />
          <DashboardCard
            title="Total Loans"
            icon={<PiChartLineUpBold size={40} className="text-green-500" />}
            value={data?.loan_count}
          />
          <DashboardCard
            title="Today's Collection"
            icon={<FaCalendarDay size={40} className="text-pink-500" />}
            value={data?.today_collection_count}
          />
        </div>

        {/* Cards Row 2 - 2 cards */}
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
          <DashboardCard
            title="Daily Collection"
            icon={<FaCalendarWeek size={40} className="text-purple-500" />}
            value={data?.daily_collection_count}
          />
          <DashboardCard
            title="Weekly Collection"
            icon={<FaCalendarWeek size={40} className="text-purple-500" />}
            value={data?.weekly_collection_count}
          />
        </div>
      </div>
    </>
  );
}

export default Dashboard;
